import { Constants } from './types'

const initialState: any = {
  toggle: true,
}

export function toggleFieldsReducer(state = initialState, action: any): any {
  switch (action.type) {
    case Constants.SET_TOGGLE:
      return {
        ...state,
        toggle: action.payload,
      }
    default:
      return state
  }
}

export default toggleFieldsReducer
